var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shipment-tag"},[_c('div',{staticClass:"shipment-tag-reminder"},[_vm._v(_vm._s(_vm.reminder))]),_vm._v(" "),_c('div',{staticClass:"shipment-tag-inner"},[_c(_vm.tagName,{tag:"component"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }